import TablePrices from './TablePrices';

export default TablePrices;
